import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../hooks';
import { ConneqtPageQuery } from '../../pages/conneqt/conneqt.queryParams.interface';
import { PlayersPageQuery } from '../../pages/players/playersPage.queryParams.interface';
import { CreateIncidentPageQuery } from '../../pages/createIncident/createIncident.queryParams.interface';

// TODO: move into routes folder
export enum Pages {
  conneqt = 'conneqt',
  players = 'players',
  // TODO: should this be players as well?
  patients = 'patients',
  incident = 'incident',
}

type ValidKeys = keyof ConneqtPageQuery & keyof PlayersPageQuery;

export interface PageQueriesState {
  [Pages.conneqt]: ConneqtPageQuery;
  [Pages.players]: PlayersPageQuery;
  [Pages.patients]: PlayersPageQuery;
  [Pages.incident]: CreateIncidentPageQuery;
}

const initialState: PageQueriesState = {
  [Pages.conneqt]: {},
  [Pages.players]: {},
  [Pages.patients]: {},
  [Pages.incident]: {},
};

/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state"] }] */
export const pageQuerySlice = createSlice({
  name: 'pageQuerySlice',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    dispatchPageQueries(
      state,
      action: PayloadAction<{
        query: any; // Partial<PageQueriesState>
        pageName: Pages;
      }>,
    ) {
      // TODO: what if we want to clear all before adding payload?
      // TODO: Maybe we need to only update queryParams if they have changed because (if) all memoized selectors (i.e. createSelectors(...)) are recalculated by reference rather then by value?
      state[action.payload.pageName] = {
        ...state[action.payload.pageName],
        ...action.payload.query,
      };

      // WARNING: DON'T REMOVE null values here
      // because useAltNavStates will put the values back since it has no way of knowing what is removed and what should stay from previous state
      // OR ??????
      // remove null values
      Object.keys(state[action.payload.pageName]).forEach((key) => {
        if (state[action.payload.pageName][key as ValidKeys] === null) {
          delete state[action.payload.pageName][key as ValidKeys];
        }
      });
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {},
});

export const { dispatchPageQueries } = pageQuerySlice.actions;

export const pageQueriesSelector = (state: RootState) => {
  return state.pageQueries;
};
